module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921114149_T.22322042.jpg";